import { Link } from "react-router-dom";
import {
  Box,
  Heading,
  Text,
  useColorModeValue,
  Link as ChakraLink,
} from "@chakra-ui/react";

const ErrorPage = () => {
  return (
    <Box textAlign="center" mt="10" color={useColorModeValue("black", "white")}>
      <Heading as="h1" size="4xl" color="red.500">
        404
      </Heading>
      <Text fontSize="2xl" mt="4" color="gray.600">
        Sorry, we couldn&apos;t find this page!
      </Text>
      <ChakraLink as={Link} to="/" color="blue.500" mt="4" fontSize="lg">
        Back to Home
      </ChakraLink>
    </Box>
  );
};

export default ErrorPage;
